import { useState, useEffect, useContext } from 'react';
import { ToastContext } from '../../../../contexts/ToastContext';
import {
	Dialog,
	DialogClose,
	DialogContent,
	DialogDescription,
	DialogFooter,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '../../../../components/ui/dialog';
import {
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '../../../../components/ui/alert-dialog';

import { useParams } from 'react-router-dom';
import apiGrupo from '../../../../services/apis/apiGrupo';
import apiEmpresa from '../../../../services/apis/apiEmpresa';
import apiUnidade from '../../../../services/apis/apiUnidade';
import apiRegimes from '../../../../services/apis/apiRegimes';
import PaginationBar from '../../../../components/common/PaginationBar';
import { getParentMap } from '../../../../funcs/getParent';
import apiEnum from '../../../../services/apis/apiEnum';
import apiMaquinaGelo from '../../../../services/apis/apiMaquinaGelo';
import apiMarca from '../../../../services/apis/apiMarca';
import apiModelo from '../../../../services/apis/apiModelo';

export default function ListaMaquinasGelo({
	atualizarLista,
	pesquisar,
	funcaoModalController,
	onClose
}) {
	const [nome, setNome] = useState('');
	const [capacidadeProducao, setCapacidadeProducao] = useState(0);
	const [potencia, setPotencia] = useState(0);
	const [acionamento, setAcionamento] = useState();
	const [tiposAcionamento, setTiposAcionamento] = useState([]);
	const [tempoProducao, setTempoProducao] = useState(0);
	const [tempoDegelo, setTempoDegelo] = useState(0);

	const [idEditar, setIdEditar] = useState();
	const [itemRemovido, setItemRemovido] = useState();
	const [idRemover, setIdRemover] = useState();
	const [regimeId, setRegimeId] = useState(0);
	const [listaRegimes, setListaRegimes] = useState([]);
	const [marcaId, setMarcaId] = useState(0);
	const [modeloId, setModeloId] = useState(0);
	const [listaMarcas, setListaMarcas] = useState([]);
	const [listaModelos, setListaModelos] = useState([]);
	const { page } = useParams();
	const [pagination, setPagination] = useState();
	const [listaMaquinasGelo, setListaMaquinasGelo] = useState([]);
	const funcaoModal = funcaoModalController.funcaoModal;

	const { erro, sucesso } = useContext(ToastContext);

	function limparInputs() {
		setNome('');
		setRegimeId(0);
	}
	useEffect(() => {
		apiMaquinaGelo.fetchApi(page).then((res) => {
			setListaMaquinasGelo(res.data.items);
			setPagination(res.data);
		});
		apiEnum.getAcionamentos().then(res => {
			setTiposAcionamento(res.data);
		});
		apiMarca.fetchApi().then(res => {
			setListaMarcas(res.data);
		});
		apiRegimes.getByUnidadeId().then((res) => {
			setListaRegimes(res.data);
		});
	}, [page]);

	useEffect(() => {
		marcaId !== undefined &&
			!isNaN(marcaId) &&
			apiModelo.fetchApi(marcaId, 'Máquina gelo').then(res => {
				setListaModelos(res.data);
			})
	}, [marcaId]);

	function deletar(id) {
		apiMaquinaGelo
			.deleteApi(id)
			.then((res) => {
				atualizarLista();
				sucesso('Máquina de gelo deletado com sucesso!');
			})
			.catch((error) => {
				console.error(error.message);
				erro('Erro ao deletar máquina de gelo!');
			});
	}

	function enviar(e) {
		e.preventDefault();

		const maquinaGelo = {
			nome: nome,
			regimeId: parseInt(e.target.regimeId.value),
			acionamento: acionamento,
			tempoProducao: parseFloat(tempoProducao),
			tempoDegelo:parseFloat(tempoDegelo),
			capacidadeProducao:parseFloat(capacidadeProducao),
			potencia:parseFloat(potencia),
			modeloId:parseInt(modeloId)
		};

		if (funcaoModal === 'Adicionar') {
			apiMaquinaGelo
				.postApi(maquinaGelo)
				.then((res) => {
					limparInputs();
					sucesso('Máquina de gelo adicionado com sucesso!');
					atualizarLista();
					onClose();
				})
				.catch((error) => {
					erro('Erro ao adicionar máquina de gelo!');
					console.error(error.message);
				});
		} else if (funcaoModal === 'Editar') {
			apiMaquinaGelo
				.putApi(idEditar, maquinaGelo)
				.then((res) => {
					limparInputs();
					atualizarLista();
					sucesso('Máquina de gelo editado com sucesso!');
					onClose();
				})
				.catch((error) => {
					console.error(error.message);
					erro('Erro ao editar máquina de gelo!');
				});
		}
	}

	return (
		<>
			<Dialog>
				<div className="w-full flex flex-col items-center mt-[40px] md:px-[200px]">
					<table className="w-full">
						<thead className="border-b w-full">
							<tr>
								<th className="text-[25px] pl-[10px] text-start">
									Nome
								</th>
								<th className="text-[25px] pl-[10px] text-start">
									Regime
								</th>
							</tr>
						</thead>
						<tbody>
							{listaMaquinasGelo.map(
								(maquinaGelo, i) =>
									maquinaGelo.nome
										.toUpperCase()
										.startsWith(
											pesquisar.toUpperCase()
										) && (
										<tr
											className="border-b hover:bg-gray-200 hover:bg-opacity-5"
											key={i}
										>
											<td className="pl-[10px] text-[20px]">
												{
													maquinaGelo.nome
												}
											</td>
											<td className="flex justify-between py-1">
												<span className="text-[20px] pl-[10px]">
													{listaRegimes
														.find(regime => regime.id === maquinaGelo.regimeId)
														?.nome || 'N/A'
															}
												</span>
												<span className="flex">
													<AlertDialogTrigger>
														<div
															onClick={() => {
																const regimeId = maquinaGelo.regimeId;

																setIdEditar(
																	maquinaGelo.id
																);
																apiModelo.getById(maquinaGelo.modeloId).then(res => {
																	const modelo = res.data;
																	setMarcaId(modelo.marcaId);
																	setModeloId(modelo.id);
																})
																setNome(
																	maquinaGelo.nome
																);
																
																setAcionamento(
																	maquinaGelo.acionamento.replaceAll("_", " ")

																);
																setPotencia(
																	maquinaGelo.potencia
																);
																setTempoDegelo(
																	maquinaGelo.tempoDegelo
																);
																setTempoProducao(
																	maquinaGelo.tempoProducao
																);
																setCapacidadeProducao(
																	maquinaGelo.capacidadeProducao
																);
																setRegimeId(
																	regimeId
																);
																funcaoModalController.setFuncaoModal(
																	'Editar'
																);
															}}
														>
															<i
																className="fa-solid fa-pen-to-square text-[18px] hover:text-lightBlue"
																title="Editar"
															></i>
														</div>
													</AlertDialogTrigger>
													<DialogTrigger>
														<div
															className="mx-2.5"
															onClick={() => {
																setItemRemovido(
																	maquinaGelo.nome
																);
																setIdRemover(
																	maquinaGelo.id
																);
															}}
														>
															<i
																className="fa-solid fa-trash text-[18px] hover:text-lightBlue"
																title="Deletar"
															></i>
														</div>
													</DialogTrigger>
												</span>
											</td>
										</tr>
									)
							)}
						</tbody>
					</table>
					{
						pagination !== undefined &&
						<PaginationBar pagination={pagination} />
					}
				</div>

				<DialogContent>
					<DialogHeader>
						<DialogTitle>
							Excluir {itemRemovido}?
						</DialogTitle>
					</DialogHeader>
					<DialogDescription>
						Todos os dados associados com {itemRemovido}{' '}
						serão removidos.
					</DialogDescription>
					<DialogFooter>
						<div
							className="bg-red-600/70 py-2 px-4 rounded-md hover:bg-red-600 hover:cursor-pointer border-slate-800 border-2 transition-all duration-200 ease-in-out"
							onClick={() => deletar(idRemover)}
						>
							<DialogClose>Excluir</DialogClose>
						</div>
					</DialogFooter>
				</DialogContent>
			</Dialog>

			<AlertDialogContent>
				<form onSubmit={(e) => enviar(e)}>
					<AlertDialogHeader>
						<AlertDialogTitle>
							{funcaoModal} Máquina de gelo
						</AlertDialogTitle>
					</AlertDialogHeader>
					<div className="w-full max-h-[500px] flex justify-around my-5 px-5 flex-wrap gap-5 overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-track-primary scrollbar-thumb-darkaccent">
						{/* NOME */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="nome"
							>
								Nome
							</label>
							<input
								id="nome"
								name="nome"
								type="text"
								placeholder="nome da máquina de gelo"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={nome}
								onChange={(e) =>
									setNome(e.target.value)
								}
								required
							/>
						</div>
						{/* CAPACIDADE DE PRODUÇÃO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="capacidadeProducao"
							>
								Capacidade de produção
							</label>
							<input
								id="capacidadeProducao"
								name="capacidadeProducao"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={capacidadeProducao}
								onChange={(e) =>
									setCapacidadeProducao(
										e.target.value
									)
								}
								required
							/>
						</div>

						{/* ACIONAMENTO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="acionamento"
							>
								Acionamento
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="acionamento"
								id="acionamento"
								required
								value={acionamento}
								onChange={(e) =>
									setAcionamento(
										e.target.value
									)
								}
							>
								<option label="   "></option>
								{
									tiposAcionamento.map((tipo, i) => (
										<option key={i} value={tipo}>{tipo}</option>	
									))
								}
							</select>
						</div>
						{/* TEMPO DE PRODUÇÃO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="tempoProducao"
							>
								Tempo de produção
							</label>
							<input
								id="tempoProducao"
								name="tempoProducao"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={tempoProducao}
								onChange={(e) =>
									setTempoProducao(
										e.target.value
									)
								}
								required
							/>
						</div>
						{/* POTENCIA */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="potencia"
							>
								Potência
							</label>
							<input
								id="potencia"
								name="potencia"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={potencia}
								onChange={(e) =>
									setPotencia(
										e.target.value
									)
								}
								required
							/>
						</div>
						{/* TEMPO DE GELO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[16px] mb-2 pl-1"
								htmlFor="tempoDegelo"
							>
								Tempo de degelo
							</label>
							<input
								id="tempoDegelo"
								name="tempoDegelo"
								type="number"
								className="border-b text-[20px] p-1.5 bg-[#0b101d] rounded-t-md w-[180px]"
								value={tempoDegelo}
								onChange={(e) =>
									setTempoDegelo(
										e.target.value
									)
								}
								required
							/>
						</div>

						{/* MARCA */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="marcaId"
							>
								Marca
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="marcaId"
								id="marcaId"
								required
								value={marcaId}
								onChange={(e) =>
									setMarcaId(
										parseInt(
											e.target.value
										)
									)
								}
							>
								<option label="   "></option>
								{listaMarcas.map(
									(marca, i) => (
										<option
											value={
												marca.id
											}
											key={i}
										>
											{marca.nome}
										</option>
									)
								)}
							</select>
						</div>
						{/* MODELO */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="modeloId"
							>
								Modelo
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="modeloId"
								id="modeloId"
								required
								value={modeloId}
								onChange={(e) =>
									setModeloId(
										parseInt(
											e.target.value
										)
									)
								}
							>
								<option label="   "></option>
								{listaModelos.map(
									(modelo, i) => (
										<option
											value={
												modelo.id
											}
											key={i}
										>
											{modelo.nome}
										</option>
									)
								)}
							</select>
						</div>
						{/* REGIME ID */}
						<div className="flex flex-col justify-end">
							<label
								className="text-[18px] mb-2 pl-1"
								htmlFor="regimeId"
							>
								Regime
							</label>
							<select
								className="border-b text-[20px] h-[42.8px] bg-[#0b101d] rounded-t-md w-[180px]"
								name="regimeId"
								id="regimeId"
								required
								value={regimeId}
								onChange={(e) =>
									setRegimeId(
										parseInt(
											e.target.value
										)
									)
								}
							>
								<option label="   "></option>
								{listaRegimes
									.map((regime, i) => (
										<option
											value={
												regime.id
											}
											key={i}
										>
											{regime.nome}
										</option>
									))}
							</select>
						</div>
					</div>
					<AlertDialogFooter>
						<div className="flex w-full justify-end gap-x-4 p-4">
							<AlertDialogAction className="w-32">
								Confirmar
							</AlertDialogAction>
							<div onClick={onClose}>
								<AlertDialogCancel className="w-32">
									Cancelar
								</AlertDialogCancel>
							</div>
						</div>
					</AlertDialogFooter>
				</form>
			</AlertDialogContent>
		</>
	);
}
